.wiki-page {
  background: transparent url(../../assets/media/grey-bg_960px.svg) no-repeat 0% 0%;
  background-size: 50%;
  border-top: 1px solid#2222221F;

  .container {
    max-width: 1248px;
    margin: 0 auto;
    padding-left: 20px;
    padding-right: 20px;

    .top-heading {
      padding: 60px 0;

      h3 {
        color: #222222;
        font-size: 16px;
        line-height: 27px;
        font-weight: 600;
        margin: 0 0 10px;
      }

      h1 {
        color: #222222;
        font-size: 44px;
        line-height: 53px;
        font-weight: 600;
        margin: 0 0 20px;
      }

      p {
        font-size: 18px;
        line-height: 27px;
      }
    }

    .container-box {
      border-top: 1px solid #2222221F;
      padding: 33px 0;

      h2 {
        font-size: 31px;
        line-height: 41px;
        margin: 0 0 20px;
      }

      p {
        font-size: 18px;
        line-height: 27px;
      }

      ul {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        list-style: none;
        padding: 0;
        margin: 30px -10px 0;

        li {
          margin: 0 10px 30px;

          a {
            font-size: 22px;
            line-height: 29px;
            color: #222222;
            text-decoration: none;

            img {
              display: block;
              margin-bottom: 10px;
              width: 100%;
              height: auto;
            }

            &:hover {
              color: #0076C0;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 920px) {
  .wiki-page {
    .container {
      .container-box {
        ul {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .wiki-page {
    .container {
      .container-box {
        border-top: 1px solid #2222221F;
        padding: 33px 0;

        ul {
          grid-template-columns: repeat(1, 1fr);
        }
      }
    }
  }
}
